/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appActions from "../../core/app.store";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
    TextField,
} from "@material-ui/core";

function DropdownAutocomplete(props) {
    const {
        listItems,
        onChangeItems,
    } = props;

    const defaultValue = props.defaultValue?props.defaultValue:[]

    const handleOnSelect = (item) => {
        onChangeItems(item);
    }

    return (
        <div className="collapse-item">
            {
                (listItems && listItems.length > 0) && (
                    <Autocomplete
                        options={listItems}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        onChange={(event, newValue) => {
                            handleOnSelect(newValue);
                        }}

                        defaultValue={defaultValue}

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="itemId"
                                variant="outlined"
                                size="small"
                            />
                        )}
                    />
                    )
            }
            </div>
  );
}

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) =>
    ({}
  );

export default (connect(mapStateToProps, mapDispatchToProps)(DropdownAutocomplete));
